const P = (n) => `/images/casa/photo-${String(n).padStart(2, "0")}.webp`;
const B = (n) => `/images/booking/b${String(n).padStart(2, "0")}.jpg`;

export const SITE_URL = "https://casa-vacanza-margherita.it";
export const BOOKING_URL = "https://www.booking.com/hotel/it/residenza-margherita-one-step-from-sea-and-culture.it.html";
export const PHONE_DISPLAY = "+39 338 626 4991";
export const PHONE_INTL = "393386264991";
export const EMAIL = "ResidenzaMargherita@hotmail.com";
export const ADDRESS = "Via Vincenzo Bellini 75, 97017 Santa Croce Camerina (RG), Sicilia";

export const waLink = (text) =>
  `https://wa.me/${PHONE_INTL}?text=${encodeURIComponent(text)}`;

export const photos = {
  hero: P(1),
  cucinaTavola: B(1),
  cucinaDettaglio: P(4),
  cucinaWide: B(1),
  limoni: P(6),
  soggiorno: B(2),
  soggiornoTv: B(4),
  mandala: P(9),
  matrimoniale: B(7),
  matrimonialeDetail: B(6),
  bagno: P(11),
  bagnoWide: P(12),
  castello: B(8),
  castello2: P(14),
  singola: "/images/casa/singola-new.webp",
  regalo: P(16),
  marinaPorto: P(18),
  puntaSecca: P(19),
  spiaggiaTramonto: P(20),
  modica: P(21),
  amiciPelosi: P(22),
  soggiornoDettaglio: B(3),
  divano: B(5),
  ragusaIbla: P(24),
  portaMare: P(25),
};

const U = {
  scicli: "https://images.unsplash.com/photo-1691319682527-b5d92c048cc8?crop=entropy&cs=srgb&fm=jpg&q=85",
  noto: "https://images.unsplash.com/photo-1598624261660-f72a3bef745c?crop=entropy&cs=srgb&fm=jpg&q=85",
  donnalucata: "https://images.unsplash.com/photo-1708029523704-38e43b9ca056?crop=entropy&cs=srgb&fm=jpg&q=85",
  natura: "https://images.unsplash.com/photo-1602566126756-c5d59c4a560d?crop=entropy&cs=srgb&fm=jpg&q=85",
  famiglia: "https://images.unsplash.com/photo-1649520387833-6d77917dbbd2?crop=entropy&cs=srgb&fm=jpg&q=85",
  famiglia2: "https://images.unsplash.com/photo-1790360594485-99b1b45c041b?crop=entropy&cs=srgb&fm=jpg&q=85",
  trekking: "https://images.unsplash.com/photo-1768557411279-97eee5d3c76c?crop=entropy&cs=srgb&fm=jpg&q=85",
  viaggiatori: "https://images.unsplash.com/photo-1560879916-200c655f2a12?crop=entropy&cs=srgb&fm=jpg&q=85",
  relax: "https://images.unsplash.com/photo-1546121519-91d95d8fa183?crop=entropy&cs=srgb&fm=jpg&q=85",
  ceramiche: "https://images.unsplash.com/photo-1519122114654-d665e49b122e?crop=entropy&cs=srgb&fm=jpg&q=85",
  maiolica: "https://images.unsplash.com/photo-1683904627610-87f36182142a?crop=entropy&cs=srgb&fm=jpg&q=85",
  cannoli: "https://images.unsplash.com/photo-1749767138348-2e5bf1cbcef2?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const rooms = [
  {
    id: "matrimoniale",
    img: photos.matrimoniale,
    gallery: [photos.matrimoniale, photos.matrimonialeDetail],
  },
  {
    id: "singola",
    img: photos.singola,
    gallery: [photos.singola],
  },
  {
    id: "castello",
    img: photos.castello,
    gallery: [photos.castello, photos.castello2],
  },
];

export const galleryItems = [
  { src: B(2), cat: "casa" },
  { src: B(4), cat: "casa" },
  { src: B(5), cat: "casa" },
  { src: B(3), cat: "casa" },
  { src: B(1), cat: "cucina" },
  { src: P(5), cat: "cucina" },
  { src: B(7), cat: "camere" },
  { src: B(6), cat: "camere" },
  { src: P(15), cat: "camere" },
  { src: B(8), cat: "camere" },
  { src: P(14), cat: "camere" },
  { src: P(11), cat: "spazi" },
  { src: P(12), cat: "spazi" },
  { src: P(4), cat: "dettagli" },
  { src: P(6), cat: "dettagli" },
  { src: P(9), cat: "dettagli" },
  { src: P(16), cat: "dettagli" },
  { src: P(22), cat: "dettagli" },
  { src: P(1), cat: "territorio" },
  { src: P(18), cat: "territorio" },
  { src: P(19), cat: "territorio" },
  { src: P(20), cat: "territorio" },
  { src: P(21), cat: "territorio" },
  { src: P(24), cat: "territorio" },
  { src: P(25), cat: "territorio" },
];

export const destinations = [
  { id: "santacroce", time: "0", img: U.maiolica },
  { id: "puntasecca", time: "6", img: photos.puntaSecca },
  { id: "marina", time: "6", img: photos.marinaPorto },
  { id: "donnalucata", time: "15", img: U.donnalucata },
  { id: "scicli", time: "25", img: U.scicli },
  { id: "modica", time: "30", img: photos.modica },
  { id: "ragusa", time: "30", img: photos.ragusaIbla },
  { id: "noto", time: "50", img: U.noto },
];

export const experienceImages = {
  mare: photos.spiaggiaTramonto,
  barocco: photos.modica,
  enogastronomia: U.cannoli,
  borghi: photos.ragusaIbla,
  famiglia: U.famiglia,
  natura: U.natura,
  relax: U.relax,
  cultura: U.ceramiche,
  escursioni: U.trekking,
};

export const audienceImages = {
  coppie: photos.portaMare,
  famiglie: "https://images.unsplash.com/photo-1528605248644-14dd04022da1?crop=entropy&cs=srgb&fm=jpg&q=85",
  gruppi: "https://images.unsplash.com/photo-1506869640319-fe1a24fd76dc?crop=entropy&cs=srgb&fm=jpg&q=85",
  viaggiatori: U.viaggiatori,
};

export const reviewScore = {
  score: "9,9",
  count: 10,
  cats: [
    { k: "cleanliness", v: 10 },
    { k: "comfort", v: 10 },
    { k: "value", v: 10 },
    { k: "staff", v: 9.7 },
    { k: "facilities", v: 9.7 },
    { k: "location", v: 9.4 },
  ],
};

export const reviews = [
  {
    name: "Martina",
    country: "Malta",
    text: "It was a very clean and well kept apartment with everything you need. Really enjoyed our stay. The owners were also very helpful and kind.",
  },
  {
    name: "Gloria",
    country: "Italia",
    text: "Abbiamo soggiornato in questa splendida casa a Marina di Ragusa e ci siamo trovati benissimo. La posizione è davvero comoda, a soli cinque minuti dal centro, perfetta per muoversi facilmente e godersi la zona.",
  },
  {
    name: "Chiara",
    country: "Italia",
    text: "La struttura è dotata di tutti i comfort ed è di una pulizia impeccabile. Ottima comunicazione con l'host che si presenta estremamente gentile e disponibile, pronto a venire in contro a ogni esigenza.",
  },
  {
    name: "Luigi",
    country: "Italia",
    text: "Casa molto accogliente e spaziosa, dotata di aria climatizzata e curata nei minimi dettagli. Adatta dalla coppia al gruppo di amici, situata in una zona strategica e comoda. In 10 minuti di macchina si arriva in spiaggia.",
  },
  {
    name: "Alex",
    country: "Italia",
    text: "La struttura era molto accogliente con tutti i servizi necessari per trascorrere la vacanza, il proprietario era disponibile e pronto ad aiutarci. Consiglio questa struttura perché il prezzo è ragionevole ed è a 10 minuti da Marina di Ragusa.",
  },
  {
    name: "Confettura",
    country: "Italia",
    text: "Posto accogliente, pulito e curato nei dettagli... ci siamo subito sentiti a casa! Staff gentilissimo e premuroso, ottima la posizione.",
  },
  {
    name: "Domenico",
    country: "Italia",
    text: "La casa è fantastica, per la colazione era disponibile caffè e tè, al nostro arrivo in frigo erano presenti acqua e bevande. La casa è dotata di climatizzatore nelle 2 camere più importanti. Portoncino di ingresso blindato.",
  },
  {
    name: "Graziella",
    country: "Italia",
    text: "La pulizia e la zona top. Casa servita di ogni cosa.",
  },
  {
    name: "Patrizia",
    country: "Italia",
    text: "La presenza di tutto ciò che serve per un soggiorno anche breve.",
  },
];

export const GOOGLE_MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Casa+vacanza+Residenza+Margherita+Via+Vincenzo+Bellini+75+Santa+Croce+Camerina";
export const googleScore = { score: "4,9", count: 16 };

export const googleReviews = [
  {
    name: "Barbara Fontana",
    country: "Italia",
    text: "Proprietario molto gentile e disponibile, casa accogliente, ottima posizione! Vacanze stupende! Consigliatissimo!",
  },
  {
    name: "Michelangelo Di Flumeri",
    country: "Italia",
    text: "La casa vacanza ha superato ogni nostra aspettativa, offrendo un soggiorno indimenticabile. Gli ambienti, arredati con gusto e attenzione ai dettagli, ci hanno fatto sentire subito a casa.",
  },
  {
    name: "Salvatore Tumino",
    country: "Italia",
    text: "Struttura accogliente, pulita e arredata con gusto, posizione a due passi dal centro: ideale per un relax in tranquillità.",
  },
];
